import * as React from "react"
import "twin.macro"
import { Link } from "gatsby"

export default function Hero() {
  return (
    <div tw="relative bg-gray-800 overflow-hidden">
      <div tw="relative pb-12 sm:pb-32">
        <main tw="mt-8 sm:mt-16 md:mt-20 lg:mt-24">
          <div tw="mx-auto max-w-screen-xl">
            <div tw="text-center">
              <div tw="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto">
                <div>
                  <h2 tw="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                    Join Our <br tw="hidden md:inline" />
                    <span tw="text-blue-400">MVFBLA Family</span>
                  </h2>
                  {/*<p tw="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">*/}
                  {/*  Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure*/}
                  {/*  qui lorem cupidatat commodo. Elit sunt amet fugiat veniam*/}
                  {/*  occaecat fugiat aliqua ad ad non deserunt sunt.*/}
                  {/*</p>*/}
                </div>
              </div>
              <a
                href="https://forms.gle/Avx9YJeGEKHqYGhK7"
                target="_blank"
                tw="inline-block rounded-full px-8 py-3 mt-8 text-sm sm:text-base sm:mt-12 sm:px-8 sm:py-4 bg-gray-100 font-bold shadow transition duration-300 bg-blue-500 text-gray-100 hocus:bg-blue-700 hocus:text-gray-200 focus:outline-none focus:shadow-outline"
              >
                FBLA Membership Form!
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
